<template>
  <component
    :is="tag"
    v-bind="$attrs"
    :to="to"
    class="btn"
    :class="btnClasses"
    @click="$emit('click', $event)"
    :disabled="disabled || pending"
  >
    <AppIcon v-if="iconName" :componentName="iconName" class="btn__icon" />

    <span class="btn__text">{{ navBtnTitles.next }}</span>

    <transition name="fade">
      <AppEmbedLoader v-if="pending" class="button-loader" />
    </transition>
  </component>
</template>

<script>
import AppEmbedLoader from "./AppEmbedLoader";
import {
  CREATING_RESUME_NAMES,
  CREATING_COVER_LETTER_NAMES,
} from "@/helpers/rout-constants";

export default {
  components: {
    AppEmbedLoader,
  },

  props: {
    title: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      default: "",
    },
    tag: {
      type: String,
      default: "button",
    },
    iconName: {
      type: String,
      default: "",
    },
    pending: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    btnClasses() {
      if (!this.className) return "";

      const btnClasses = [];

      btnClasses.push(`btn--${this.className}`);

      if (this.pending) {
        btnClasses.push("btn--pending", "btn--disabled");
      }

      return btnClasses;
    },

    navBtnTitles() {
      switch (this.$route.name) {
        case CREATING_RESUME_NAMES.STEP_1:
          return {
            next: "Continue",
            prev: "",
          };
        case CREATING_RESUME_NAMES.STEP_2:
          return {
            next: "Continue",
            prev: "Back to Header",
          };
        case CREATING_RESUME_NAMES.STEP_3:
          return {
            next: "Continue",
            prev: "Back to Work history",
          };
        case CREATING_RESUME_NAMES.STEP_4:
          return {
            next: "Continue",
            prev: "Back to Education",
          };
        case CREATING_RESUME_NAMES.STEP_5:
          return {
            next: "Finalize Resume",
            prev: "Back to Skills",
          };
        case CREATING_COVER_LETTER_NAMES.STEP_1:
          return {
            next: "Continue",
            prev: "",
          };
        case CREATING_COVER_LETTER_NAMES.STEP_2:
          return {
            next: "Finalize",
            prev: "Back to Header",
          };
        default:
          return {
            next: "Next",
            prev: "Prev",
          };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  border-radius: 8px;
  height: 55px;
  padding: 10px 20px;
  min-width: 200px;
  position: relative;
  cursor: pointer;

  &__text {
    transition: all 0.3s ease;
  }

  &__icon {
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }

  &--secondary {
    border: 1px solid $primary;

    .btn__text {
      color: $primary;
    }

    svg {
      fill: $primary;
    }

    &:hover {
      background-color: $primary;
      color: #ffffff;

      .btn__text {
        color: #ffffff;
      }

      svg {
        fill: #ffffff;
      }
    }
  }

  &--red {
    border: 1px solid $red;

    .btn__text {
      color: $red;
    }

    &:hover {
      background-color: $red;

      .btn__text {
        color: #ffffff;
      }
    }
  }

  &--primary {
    background-color: $primary;
    border: 1px solid $primary;

    .btn__text {
      color: #fff;
    }

    svg {
      fill: #fff;
    }
    &:active {
      background-color: #416fe5;
    }
  }

  &--white {
    color: $primary;
    background-color: #fff;
    border: 1px solid #fff;

    svg {
      fill: $primary;
    }

    &:hover {
      background-color: $primary;

      .btn__text {
        color: #ffffff;
      }

      svg {
        fill: #fff;
      }
    }
  }

  &--disabled,
  &:disabled {
    user-select: none;
    pointer-events: none;
    cursor: default;
    background-color: #a5baf2;
    border-color: #a5baf2;

    .btn__text {
      color: #fff;
    }
  }

  &--pending {
    .btn__text {
      opacity: 0;
    }

    .btn__icon {
      opacity: 0;
    }
  }
}
</style>
